import React from 'react';
import { Loader2 } from 'lucide-react';

export function IntegrationsLoading() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {/* ── Status Loading Message Banner ── */}
      <div style={{
        border: '1px solid rgba(56, 189, 248, 0.3)',
        borderRadius: '0',
        backgroundColor: 'rgba(56, 189, 248, 0.05)',
        padding: '16px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: '14px'
      }}>
        <Loader2 size={20} style={{ color: '#38bdf8', flexShrink: 0 }} className="animate-spin" />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '14px', fontWeight: 700, color: 'var(--admin-card-text)' }}>
            Checking for connected tools...
          </span>
          <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '12px', color: 'var(--admin-card-subtext)' }}>
            Synchronizing authentication status for Google Calendar, Outlook, Salesforce, and HubSpot.
          </span>
        </div>
      </div>

      {/* ── Skeleton Pulse Placeholders ── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {[1, 2, 3, 4].map((item) => (
          <div 
            key={item}
            style={{
              borderRadius: '0',
              padding: '16px 20px',
              border: '1px solid var(--admin-card-border)',
              backgroundColor: 'var(--admin-card-bg)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              opacity: 0.6
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{
                width: '44px',
                height: '44px',
                borderRadius: '0',
                backgroundColor: 'rgba(255, 255, 255, 0.04)',
                border: '1px solid var(--admin-card-border)'
              }} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div style={{ width: '130px', height: '14px', backgroundColor: 'rgba(255, 255, 255, 0.08)', borderRadius: '2px' }} />
                <div style={{ width: '220px', height: '10px', backgroundColor: 'rgba(255, 255, 255, 0.04)', borderRadius: '2px' }} />
              </div>
            </div>
            <div style={{ width: '80px', height: '32px', backgroundColor: 'rgba(255, 255, 255, 0.06)', borderRadius: '0' }} />
          </div>
        ))}
      </div>
    </div>
  );
}
